<template>
  <div>

  </div>
</template>
<script>
export default {
  name: 'offer-whats-app-modal'
}
</script>
